import { render, staticRenderFns } from "./List.vue?vue&type=template&id=1bfc3a89&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./Komcard.scss?vue&type=style&index=0&id=1bfc3a89&lang=scss&scoped=true&"
import style1 from "./List.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc3a89",
  null
  
)

export default component.exports